import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopySymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_6009)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.1991 12.1412H14.3854V3.64453H5.88867V6.8308",
			stroke: "black",
			strokeWidth: 1.06209,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M11.1989 6.83203H2.70215V15.3287H11.1989V6.83203Z",
			stroke: "black",
			strokeWidth: 1.06209,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_6009",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.9934,
			height: 16.9934,
			fill: "white",
			transform: "translate(0.046875 0.988281)"
		})
	}) })]
});
export default SvgCopySymbol;
